import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeComponent } from './tree/tree.component';
import {vssProviders} from '../../vss.providers';
import {VssUiControlsModule} from '../controls/vss-ui-controls.module';
import {NzTreeModule} from 'ng-zorro-antd/tree';
import {FormsModule} from '@angular/forms';
import {PipeModule} from '../pipe/pipe.module';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {PermissionModule} from '../permission/permission.module';



@NgModule({
  declarations: [
    TreeComponent,
  ],
  exports: [
    TreeComponent
  ],
  imports: [
    CommonModule,
    VssUiControlsModule,
    NzTreeModule,
    FormsModule,
    PipeModule,
    NzDropDownModule,
    PermissionModule
  ],
  providers: vssProviders,
  schemas: [NO_ERRORS_SCHEMA]
})
export class TreeModule { }
